import {
    MONETATE_DETAILS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case MONETATE_DETAILS:
            return {
                ...state,
                SUBMIT_loading: false,
                monetateDetails: action.monetateDetails,
            }
        default:
            return state
    }
}